import { useEffect } from "react";
import SelectClassMenu from "../student/components/SelectClassMenu";
import repeatIcon from "../../../assets/images/Repeat.png";

const StudentAccountLinkHeader = ({
    mainClass,
    setMainClass,
    classes,
    setClasses,
    teacherName,
    schoolName,
    selectedAccountsCount,
    onLinkClick
}) => {
    // 올해 연도의 클래스만 필터링
    const currentYear = new Date().getFullYear();
    const currentYearClasses = (classes || []).filter(clazz => clazz.year === currentYear);

    // mainClass가 올해 클래스 목록에 없으면 첫 번째 클래스로 변경
    useEffect(() => {
        if (currentYearClasses.length > 0 && mainClass) {
            const isMainClassInCurrentYear = currentYearClasses.some(
                clazz => clazz.classId === mainClass.classId
            );

            if (!isMainClassInCurrentYear) {
                setMainClass(currentYearClasses[0]);
            }
        }
    }, [currentYearClasses.length, mainClass?.classId]);

    return (
        <div className="sticky top-0 z-30 bg-[#F8F8F8] w-full">
            <div className="flex flex-wrap justify-center items-center mt-[60px] min-h-[52px]">
                <div className="relative z-40 w-[572px] h-[60px]">
                    <SelectClassMenu
                        classList={currentYearClasses}
                        setClasses={setClasses}
                        mainClass={mainClass}
                        setMainClass={setMainClass}
                        setStudents={() => {}}
                        savedStudents={null}
                        isEditable={false}
                        setIsEditable={() => {}}
                        updateStudentInfo={[]}
                        setUpdateStudentInfo={() => {}}
                        fetchUpdateStudents={() => {}}
                        isModStudentConsent={false}
                        setIsModStudentConsent={() => {}}
                    />
                </div>
            </div>

            {/* 선생님 정보와 연동하기 버튼 */}
            <div className="w-full max-w-[1044px] mx-auto flex items-center justify-between my-3">
                <div className="w-[160px]"></div>
                <div className="text-[#50555F] text-[20px] font-medium">
                    {teacherName && teacherName}&nbsp;|&nbsp;{schoolName && schoolName}
                </div>

                <button
                    onClick={onLinkClick}
                    className="flex items-center justify-center gap-2 w-[160px] h-[44px] bg-[#7494FF] text-white rounded-[200px] font-semibold text-[20px] hover:opacity-80 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={selectedAccountsCount === 0}
                >
                    <img src={repeatIcon} alt="연동" className="w-5 h-5" />
                    <span className="text-[20px]">연동하기</span>
                    <span className="flex items-center justify-center w-[22px] h-[22px] bg-white text-[#7494FF] rounded-full text-[12px] font-[900]">
                        {selectedAccountsCount}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default StudentAccountLinkHeader;
